module.exports = __webpack_public_path__ + "img/04-10.3b3ab1e5.png";